/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} For_Whom_Diet_KcalInputs */

const en_for_whom_diet_kcal = /** @type {(inputs: For_Whom_Diet_KcalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2,300 kcal`)
};

const pl_for_whom_diet_kcal = /** @type {(inputs: For_Whom_Diet_KcalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2 300 kcal`)
};

/**
* | output |
* | --- |
* | "2,300 kcal" |
*
* @param {For_Whom_Diet_KcalInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const for_whom_diet_kcal = /** @type {((inputs?: For_Whom_Diet_KcalInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<For_Whom_Diet_KcalInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_for_whom_diet_kcal(inputs)
	return en_for_whom_diet_kcal(inputs)
});